import { useState } from 'react';
import HeroSection from './HeroSection';
import GalleryFilterSection from './GalleryFilterSection';
import PhotoGridSection from './PhotoGridSection';
import LightboxSection from './LightboxSection';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (image, images) => {
    setLightboxImage({ image, images });
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <GalleryFilterSection activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
      <PhotoGridSection activeFilter={activeFilter} onImageClick={openLightbox} />
      {lightboxImage && (
        <LightboxSection
          image={lightboxImage.image}
          images={lightboxImage.images}
          onClose={closeLightbox}
        />
      )}
    </div>
  );
};

export default Gallery;
